function Lead() {
  window.open("https://aeitb7ixl0p.typeform.com/to/Tu3HS7Br", "_blank");
}

function Login() {
  window.location.href = "login";
}

export { Lead, Login };
